import { useMemo } from 'react';
import {
  ReactCompareSlider,
  ReactCompareSliderHandle,
  ReactCompareSliderImage,
} from 'react-compare-slider';

export const PictureCard = ({
  leftImage,
  rightImage,
  onClick,
  changePositionOnHover,
}: {
  leftImage?: string;
  rightImage?: string;
  onClick?: () => void;
  changePositionOnHover?: boolean;
}) => {
  const isClickable = useMemo(() => onClick && typeof onClick === 'function', [onClick]);

  return (
    <ReactCompareSlider
      className="step-image-comparison"
      onClick={onClick}
      changePositionOnHover={changePositionOnHover}
      handle={
        <ReactCompareSliderHandle
          buttonStyle={{
            WebkitBackdropFilter: undefined,
            backdropFilter: undefined,
            backgroundColor: 'white',
            border: 0,
            boxShadow: undefined,
            color: '#444',
            cursor: isClickable ? 'pointer' : 'ew-resize',
          }}
          linesStyle={{ opacity: 0.5, cursor: isClickable ? 'pointer' : 'ew-resize' }}
        />
      }
      itemOne={<ReactCompareSliderImage src={leftImage} alt="Original" />}
      itemTwo={<ReactCompareSliderImage src={rightImage} alt="Analyzed" />}
    />
  );
};
